<template>
  <b-dropdown-item v-if="!isIssued"
    :style="{cursor: 'pointer'}"
    @click="$emit('issue-pass')"
  >
    <img class="menu-item-img icon-pdf"
      :src="iconPath('v_pass.svg')"
      alt="Выдать пропуск"/>
    {{ this.title }}
  </b-dropdown-item>
</template>

<script>
export default {
  props: {
    isIssued: {
      type: Boolean
    },
    title: {
      type: String,
      required: true
    }
  },

  methods: {
    iconPath(baseName) {
      return require('@/common/assets/img/icons/menuVisitor/' + baseName)
    }
  }
}
</script>
